import { IStoreCartState } from "~/types/store/cart";

const state: () => IStoreCartState = () => ({
    cart: null,
    offers: null,
    services: null,
    payType: 1,
    personalInfo: null,
    selectedServices: null,
    updatingItems: new Set(),
    comment: '',
});

export default state;
